import { transformBlockquotes } from './blockquote';
import { preprocessEmbeds } from './embeds';

type TextProcessor = (text: string) => string;

const textProcessors: TextProcessor[] = [preprocessEmbeds, transformBlockquotes];

export function preprocessText(text: string): string {
    return textProcessors.reduce((acc, processor) => processor(acc), text);
}
